// extracted by mini-css-extract-plugin
export default {"calendars":"styles_calendars__2lxyk","rot":"styles_rot__pDsWW"};